import { render, staticRenderFns } from "./SliderRU.vue?vue&type=template&id=35b486ef&scoped=true"
import script from "./SliderRU.vue?vue&type=script&lang=js"
export * from "./SliderRU.vue?vue&type=script&lang=js"
import style0 from "./SliderRU.vue?vue&type=style&index=0&id=35b486ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b486ef",
  null
  
)

export default component.exports